import { Icon, type IconName } from '../../../ui/index.js';

export function Status({
  icon,
  tone,
  children,
}: {
  icon: IconName;
  tone: 'muted' | 'warn' | 'success';
  children: React.ReactNode;
}) {
  const color =
    tone === 'warn'
      ? 'var(--status-warn-fg)'
      : tone === 'success'
        ? 'var(--status-success-fg)'
        : 'var(--fg-3)';
  return (
    <div
      style={{
        fontSize: 12,
        color: 'var(--fg-3)',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
      }}
    >
      <Icon name={icon} size={14} style={{ color }} />
      <span>{children}</span>
    </div>
  );
}

export function ErrorChip({ text }: { text: string }) {
  return (
    <div
      style={{
        fontSize: 12,
        color: 'var(--status-error-fg)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
      }}
    >
      <Icon name="alert-triangle" size={14} />
      <span>{text}</span>
    </div>
  );
}

export function Field({
  label,
  required,
  children,
}: {
  label: string;
  required?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div>
      <div
        style={{
          fontSize: 11,
          color: 'var(--fg-3)',
          marginBottom: 5,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        {label}
        {required && <span style={{ color: 'var(--status-error-fg)' }}>*</span>}
      </div>
      {children}
    </div>
  );
}

export function Grid2({ children }: { children: React.ReactNode }) {
  return <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>{children}</div>;
}

export function Card({
  children,
  padded = true,
  style,
}: {
  children: React.ReactNode;
  padded?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <div
      style={{
        background: 'var(--bg-1)',
        border: '1px solid var(--border-1)',
        borderRadius: 'var(--r-2)',
        padding: padded ? '14px 16px' : 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
